import { ReplaySubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Injectable, OnDestroy } from '@angular/core';

import { IComponentUpdateEvent } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class SnComponentUpdater<E = any> implements OnDestroy {
  private readonly _updated$ = new ReplaySubject<IComponentUpdateEvent<E>>(Infinity, 200);

  constructor() {}

  public ngOnDestroy(): void {
    this._updated$.complete();
  }

  /**
   * Subscribe to component updates
   * @param component - Name of component
   */
  public componentUpdated$(component: string): Observable<E> {
    return this._updated$.asObservable().pipe(
      filter((data) => data.component === component),
      map((data) => data.event),
    );
  }

  /**
   * Send event to component
   * @param component - Name of component
   * @param event - Event to component
   */
  public updateComponent(component: string, event: E): void {
    this._updated$.next({ component, event });
  }
}
